import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { DemoProvider } from './demo/DemoContext';

if (import.meta.env.VITE_DEMO_MODE === 'true') {
  import('./demo/demo.css');
}

// SaaS mode wraps the app with gateway auth (email/password login)
// Set VITE_SAAS=1 at build time to enable
const isSaas = import.meta.env.VITE_SAAS === '1';

async function render() {
  let RootComponent: React.ComponentType;
  if (isSaas) {
    const mod = await import('./SaasApp');
    RootComponent = mod.default;
  } else {
    const mod = await import('./App');
    RootComponent = mod.default;
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <DemoProvider>
        <RootComponent />
      </DemoProvider>
    </React.StrictMode>
  );
}

render();
